import script from "./DocumentDownloadLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentDownloadLayout.vue?vue&type=script&setup=true&lang=js"

import "./DocumentDownloadLayout.vue?vue&type=style&index=0&id=9f4bdcdc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f4bdcdc"]])

export default __exports__